import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const schedule = {
  path: '/nurseOfficePhy',
  component: Layout,
  name: 'nurseOfficePhy',
  redirect: '/nurseOfficePhy/index',
  children: [{
    path: '/nurseOfficePhy/index',
    component: () => import('@/views/nurseOfficePhy/index'),
    name: 'nurseOfficePhy.index',
    meta: {
      title: i18n.t(`message.nurse_office`)
    }
  }, ]
}

export default schedule